export function sanitizeErrorMessage(message: string): string {
    // Replace file paths with 2 forward slashes and Windows or Unix-like file paths
    message = message.replace(/\/[^\\/\s]+\/[^\\/\s]*/g, "[FILE_PATH]");
    message = message.replace(/[a-zA-Z]:\\(?:[^\\/:*?"<>|\r\n]+\\)*[^\\/:*?"<>|\r\n]+/g, "[FILE_PATH]");

    // Remove certificate blocks
    message = message.replace(/-----BEGIN CERTIFICATE-----[\s\S]*?-----END CERTIFICATE-----/g, "[CERTIFICATE REDACTED]");

    // Remove headers and payload data
    message = message.replace(/("headers":{[^}]+})/g, '"headers":[REDACTED]');
    message = message.replace(/("data":{[^}]+})/g, '"data":[REDACTED]');

    // Replace sensitive query params in URLs
    message = message.replace(/(\?.*?)\b(=[^&]*)/g, "[QUERY_PARAMS_REDACTED]");

    // Optional: Remove long stack trace details
    message = message.replace(/(at\s+[^\n]+)/g, "[STACK_TRACE_LINE]");

    // Return sanitized message
    return message;
}
